module.exports = __webpack_public_path__ + "img/chaBing2.a1675126.png";